import classNames from 'classnames';
import styles from './CheckboxWithTitle.module.scss';

const CheckboxWithTitle = ({
  children,
  onChange,
  checked,
  name,
  reverse,
  className,
}) => {
  return (
    <label
      className={classNames(styles.radio, className, {
        [styles.reverse]: reverse,
      })}
      itemScope
      itemType='https://schema.org/CheckAction'
    >
      <input
        name={name}
        type={'checkbox'}
        onChange={onChange}
        value={false}
        checked={checked}
        aria-label={name}
      />
      <div className={styles.title}>
        <span>{children}</span>
      </div>
    </label>
  );
};

export default CheckboxWithTitle;
